import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toggle-content__body" }
const _hoisted_2 = { class: "toggle-content__btn" }

import { ref, withDefaults } from "vue";
import {
  mapModifires,
  mergeModifires,
  type typeModifires,
} from "@/components/utils/modifires";
import { InlineLink } from "../";

interface Props {
  modifires?: typeModifires;
  opend?: boolean;
  text?: {
    open?: string;
    close?: string;
  };
}

export default /*#__PURE__*/_defineComponent({
  __name: 'toggle-content',
  props: {
    modifires: { type: [String, Array, Boolean] },
    opend: { type: Boolean, default: false },
    text: { default: () => ({}) }
  },
  emits: ["toggle"],
  setup(__props: any, { emit }) {

const props = __props;





const isOpend = ref(props.opend);
const btnText = ref(props.opend ? props.text.close : props.text.open);

const componentClass = () =>
  mapModifires(
    "toggle-content",
    mergeModifires(props.modifires, isOpend.value && "opend")
  );

const toggle = () => {
  isOpend.value = !isOpend.value;
  btnText.value = isOpend.value ? props.text.close : props.text.open;
  emit("toggle", isOpend.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(componentClass())
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InlineLink), { onClick: toggle }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(btnText.value), 1)
        ]),
        _: 1
      })
    ])
  ], 2))
}
}

})